import FormAutocomplete from "./FormAutocomplete";
import FormCheckbox from "./FormCheckbox";
import FormDatePicker from "./FormDatePicker";
import FormRadio from "./FormRadio";
import FormTextField from "./FormTextField";
import FormInputProps from "./Types";
import FormNumberInput from "./FormNumberInput";

const FormInput = <
  T extends (string | number | boolean) | (string | number | boolean)[] = string
>(
  props: FormInputProps<T>
) => {
  if (props.type === "text" || props.type === "password") {
    return <FormTextField {...props} />;
  } else if (props.type === "select") {
    return <FormAutocomplete {...props} />;
  } else if (props.type === "checkbox") {
    return <FormCheckbox {...props} />;
  } else if (props.type === "radio") {
    return <FormRadio {...props} />;
  } else if (props.type === "date") {
    return <FormDatePicker {...props} />;
  } else if (props.type === "number") {
    return <FormNumberInput {...props} />;
  }

  return null;
};

export default FormInput;
